import { render, staticRenderFns } from "./ActivityReportItem.vue?vue&type=template&id=0bd335d6&scoped=true&"
import script from "./ActivityReportItem.vue?vue&type=script&lang=js&"
export * from "./ActivityReportItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityReportItem.vue?vue&type=style&index=0&id=0bd335d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd335d6",
  null
  
)

export default component.exports